import Header from "@/components/feature/Header";
import Footer from "@/components/feature/Footer";
import PageHead from "@/components/feature/PageHead";

const COMPANY_NAME = "NetBasis International";

const title = "Análisis de mercado";
const h1Text = "Análisis de mercado profundos para una entrada exitosa en el mercado de la región DACH. Como su interfaz operativa, le proporcionamos business intelligence precisa y servicios de investigación de mercado para comprender exactamente las necesidades del mercado, el tamaño del mismo y la competencia establecida en Alemania, Austria y Suiza.";
const heroImage = "https://net-basis.net/Bilder/market-analysis-business-intelligence-dach-market-entry.webp";
const heroAlt = "Un empresario analiza datos digitales de mercado para orientar la entrada en el mercado.";
const heroClaimLine1 = "¡Entender los mercados!";
const heroClaimLine2 = "¡Decidir con seguridad!";
const benefitsTitle = "Cómo se beneficia de nuestra experiencia en __análisis de mercado__:";
const p1Text = "NetBasis International ofrece a sus clientes un paquete integral de servicios de investigación de mercado como componente esencial de su estrategia comercial y, al mismo tiempo, factor clave decisivo en la competencia. Suministramos a los fabricantes extranjeros de TIC toda la información pertinente necesaria para tomar decisiones comerciales fundamentadas y seguras sobre el terreno.";
const p1Parts = p1Text.split(COMPANY_NAME);
const bottomClaim = "NetBasis International - drive to excellence with excellent drivers !";

const benefits = [
  "Análisis de las tendencias del mercado, las actividades del mercado y las temáticas del sector",
  "Evaluación del tamaño del mercado, de las características específicas del mercado y de las tendencias",
  "Informes de antecedentes sobre los competidores extranjeros y su despliegue local, sus clientes y sus socios o compradores",
  "Definición estratégica de estrategias de marketing y de gestión a medida",
  "Definiciones precisas del mercado segmentadas por grupos de socios y de clientes potenciales",
  "Definición de proveedores, clientes y socios, distribuidores o comerciantes",
  "Revisión y aclaración de todos los procedimientos regulatorios y directrices locales",
];

export default function AnalisisDeMercadoEsPage() {
  return (
    <div className="min-h-screen flex flex-col">
      <PageHead
        title="Análisis de Mercado | NetBasis International"
        description="Datos fundamentados y perspectivas precisas sobre la región DACH como base sólida para sus decisiones de expansión estratégica."
        ogUrl="https://net-basis.net/es/servicios/desarrollo-de-negocio/analisis-de-mercado"
      />
      <Header />

      <main className="flex-1 pt-20 md:pt-24">
        {/* Hero image */}
        <section className="w-full bg-white py-4 md:py-6 lg:py-8">
          <div className="w-full max-w-[1100px] mx-auto">
            <div className="relative w-full h-[320px] md:h-[420px] lg:h-[500px] overflow-hidden">
              <img loading="lazy"
                src={heroImage}
                alt={heroAlt}
                title={title}
                className="absolute inset-0 w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/50"></div>

              <div className="absolute inset-0 z-20 flex items-start justify-end pt-[6%] md:pt-[4%] lg:pt-[3%] pr-[8%] md:pr-[4%] lg:pr-[4%] pointer-events-none">
                <p
                  className="text-[1.625rem] md:text-4xl lg:text-5xl font-normal text-white drop-shadow-[0_1px_4px_rgba(0,0,0,0.6)] text-right marktanalysen-hero-text-slide ma-hero-lh-15"
                  style={{ fontFamily: '"Open Sans", sans-serif' }}
                >
                  <span className="block">{heroClaimLine1}</span>
                  <span className="block">{heroClaimLine2}</span>
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Content */}
        <section className="py-6 md:py-8 px-4 md:px-6 lg:px-8 bg-white">
          <div className="max-w-5xl mx-auto">
            <h2 className="font-heading text-lg md:text-xl font-bold text-primary-600 mb-5 md:mb-7">
              {title}
            </h2>

            <h1 className="font-semibold text-foreground-950 leading-relaxed text-base mb-4">
              {h1Text}
            </h1>

            <div className="space-y-4 text-foreground-950 leading-relaxed text-base">
              <p>
                {p1Parts.map((part, i) => (
                  <span key={i}>
                    {part}
                    {i < p1Parts.length - 1 && (
                      <strong className="text-primary-600">{COMPANY_NAME}</strong>
                    )}
                  </span>
                ))}
              </p>
            </div>

            <h2 className="font-heading text-lg md:text-xl font-bold text-primary-600 mt-8 md:mt-10 mb-5 md:mb-7">
              {benefitsTitle.split("__").map((part, i) =>
                i % 2 === 1 ? <em key={i} className="mr-[0.15em]">{part}</em> : part
              )}
            </h2>

            <div className="space-y-1.5 md:space-y-2 text-foreground-950 leading-relaxed text-base">
              {benefits.map((benefit, idx) => (
                <div key={idx} className="flex items-start gap-2 md:gap-3">
                  <div className="w-5 h-5 flex-shrink-0 flex items-center justify-center mt-0.5">
                    <i className="ri-check-line text-primary-600 text-base md:text-lg"></i>
                  </div>
                  <p>{benefit}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Bottom claim */}
        <section className="py-6 md:py-10 px-4 md:px-6 lg:px-8 bg-white">
          <div className="max-w-5xl mx-auto text-center">
            <p className="font-heading text-lg md:text-xl font-bold text-primary-600">
              {bottomClaim}
            </p>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}